import React, { useEffect,useState } from 'react';
import { Avatar, IconButton, Box } from '@mui/material';
import UploaderIcon from '../assests/imguploader.png';
import Gallery from '../assests/gallery.png';
import configuration from '../../config/Config';

function ImageUploader({ data = 'Upload Image', picture, setPicture, avatarSize = 120 }) {
  const [previewImage, setPreviewImage] = useState(Gallery);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPicture(file);
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    if (picture && !(picture instanceof File)) {
      setPreviewImage(`${configuration.cdnFront}/${picture}`);
    }
  }, [picture]);

  useEffect(() => {
    // Clean up the object URL when component unmounts or when picture changes
    return () => {
      if (picture instanceof File) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [picture, previewImage]);

  return (
    <Box sx={{ textAlign: 'center', mt: 4 }}>
      <Box sx={{ position: 'relative', display: 'inline-block' }}>
        <Avatar
          sx={{
            width: avatarSize,
            height: avatarSize,
            backgroundColor: '#FFF',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            overflow: 'hidden',
          }}
        >
          <img
            src={previewImage}
            alt="Uploaded"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Avatar>
        <label htmlFor="image-upload">
          <IconButton
            component="span"
            sx={{
              position: 'absolute',
              bottom: 20,
              right: 0,
              backgroundColor: '#FFF',
              borderRadius: '50%',
            }}
          >
            <img src={UploaderIcon} alt="Upload Icon" style={{ width: '24px', height: '24px' }} />
          </IconButton>
        </label>
        <input
          id="image-upload"
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleImageUpload}
        />
      </Box>
      <Box sx={{ mt: 1, color: '#8d8d8d', fontSize: '14px', fontFamily: 'Heebo' }}>
        {data}
      </Box>
    </Box>
  );
}

export default ImageUploader;
